/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_CreatedInputs */

const en_admin_posts_created = /** @type {(inputs: Admin_Posts_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post created`)
};

const zh_admin_posts_created = /** @type {(inputs: Admin_Posts_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章已创建`)
};

/**
* | output |
* | --- |
* | "Post created" |
*
* @param {Admin_Posts_CreatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_created = /** @type {((inputs?: Admin_Posts_CreatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_CreatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_created(inputs)
	return zh_admin_posts_created(inputs)
});
export { admin_posts_created as "admin.posts.created" }